import Configuration from '../model/configuration';

/**
 * Configuration service
 * @type {{init: (function()), getConfigurationSvc: (function())}}
 */
export const ConfigurationSvc = {
  /**
   * Initialize configuration service
   */
  init() {
    this.configSvc = new Configuration();
  },

  /**
   * Get configuration service
   * @returns {Configuration | ConfigurationSvc}
   */
  getConfigurationSvc() {
    return this.configSvc;
  },
};



// WEBPACK FOOTER //
// configuration.service.js